module.exports = __webpack_public_path__ + "static/Street Food Specs 2026-bcc87815b2503e4e615c45988aff05eb.pdf";